module.exports = __webpack_public_path__ + "static/media/C004.84bad5a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C004.jpg
// module id = 287
// module chunks = 0